import React, { useEffect } from 'react';

import { Pagination } from '@mui/material';

import classes from './FoodScoreTable.module.scss';
import { FoodInfoRow } from '../FoodInfoRow/FoodInfoRow';
import { FoodScoreTableHead } from '../FoodScoreTableHead/FoodScoreTableHead';
import { FoodScorePageResponse } from '../../../../interfaces/FoodScorePageResponse';

type FoodScoreTableProps = {
  tableData: FoodScorePageResponse;
  getTableData: (page?: number) => void;
};

const FoodScoreTable = ({ tableData, getTableData }: FoodScoreTableProps) => {
  const { content, number, totalPages, last } = tableData;

  const reloadTableIfPageScored = () => {
    const isLastFoodOnPage = content.length === 0;

    if (isLastFoodOnPage && !last) {
      getTableData();
    }
  };

  useEffect(() => {
    reloadTableIfPageScored();
  }, [content]);

  const isShowPagination = totalPages > 1;
  const pageChangeHandler = (_: React.ChangeEvent<unknown>, page: number) =>
    getTableData(page - 1);

  return (
    <>
      <div className={classes.foodScoreTable}>
        <FoodScoreTableHead />
        {content.map((food) => (
          <FoodInfoRow food={food} key={food.foodId} />
        ))}
      </div>
      {isShowPagination && (
        <Pagination
          className={classes.pagination}
          count={totalPages}
          onChange={pageChangeHandler}
          page={number + 1}
        />
      )}
    </>
  );
};

export { FoodScoreTable };
